module.exports = __webpack_public_path__ + "static/img/business-wheel.052cb73.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/buyer-listing-details-as-pdf/assets/business-wheel.png
// module id = Vhbk
// module chunks = 0